export { renderSkeleton_unstable as renderSkeleton } from '@fluentui/react-skeleton';
